<template>
  <div class="space-y-4">
    <h2 class="text-lg font-medium">{{ t('plugin.steps.payment') }}</h2>
    <p v-if="submitting" class="text-gray-500">{{ t('plugin.loading') }}</p>
    <p v-else-if="submitError" class="text-red-600">{{ submitError }}</p>
    <p v-else-if="state.submitted" class="text-green-600">{{ t('plugin.notifications.reservationCreated') }}</p>
    <div v-else class="space-y-2 text-sm text-gray-600 dark:text-gray-400">
      <p>{{ t('plugin.paymentStep.instructions') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useWizardState } from '@/composables/useWizardState'
import { t } from '@/i18n'

defineProps<{
  submitting?: boolean
  submitError?: string | null
}>()

const state = useWizardState()
</script>
